import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=57aa45fa&"
import script from "./task-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./task-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./task-list.vue?vue&type=style&index=0&id=57aa45fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./task-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports